
export default {
  setup: 'Setup',
  driverExperience: 'Driver Experience',
};
